import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomTextField } from '../../../../../../../../components/CustomTextField';
import CustomRadioGroup from '../../../../../../../../components/CustomRadioGroup';
import CustomRadio from '../../../../../../../../components/CustomRadio';
import {CALCULATION_TYPE_MODEL, getCalculationTypeById, POLICY_CONDITION_MODEL} from '../Model/Model';
import {CustomSelect} from "../../../../../../../../components/CustomSelect";
import WeeklyRecurrenceScope from "./WeeklyRecurrenceScope";
import DateRangeScope from "./DateRangeScope";
import HourScope from "./HourScope";
import BonusScope from "./BonusScope";

// Maps a rule condition to its scope editor. Kept here (the only consumer) so the
// data Model does not import view components, which created a circular dependency.
const SCOPE_MAP = {
    [POLICY_CONDITION_MODEL.WEEKLY_RECURRENCE.key]: WeeklyRecurrenceScope,
    [POLICY_CONDITION_MODEL.DATE_RANGE.key]:        DateRangeScope,
    [POLICY_CONDITION_MODEL.HOUR.key]:              HourScope,
    [POLICY_CONDITION_MODEL.BONUS.key]:             BonusScope,
};
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
const RuleForm = ({
    rule,
    updateRuleField,
    emptyFields,
    isGlobal,
    isValid = true,
    isValidCalculationValue = true,
    isValidCalculationValueText,
    disabled=false
}) => {
    const { t } = useTranslation();
    const ScopeComponent = SCOPE_MAP[rule.condition] ?? null;

    return (
        <div className={"row mt-2"}>
            { !isGlobal &&
                <div className='col-12 px-0'>
                    <CustomTextField
                        id='txt_rf_name'
                        name='name'
                        value={rule.name}
                        trans='name'
                        type='text'
                        required
                        emptyFields={emptyFields}
                        length={128}
                        onChange={(e) => updateRuleField(e.target.name, e.target.value)}
                        disabled={disabled}
                    />
                </div>
            }

            <div className='col-12 px-0'>
                <CustomRadioGroup
                    trans={t('trigger_logic')}
                    classTitle={"ibl-font-w-700 font-color-general-950 fs-14px "}
                    required={true}
                    emptyFields={emptyFields && !rule.condition}
                    disabled={disabled}
                >
                    {POLICY_CONDITION_MODEL.values().map((opt) => (
                        <CustomRadio
                            key={opt.key}
                            id={`rbtn_rf_${opt.key}`}
                            name='condition'
                            trans={opt.trans}
                            value={opt.key}
                            checked={rule.condition === opt.key}
                            onChange={() => updateRuleField('condition', opt.key)}
                            labelClassName={"fs-14px"}
                            required={true}
                            emptyFields={emptyFields && !rule.condition}
                            disabled={disabled}
                        />
                    ))}
                </CustomRadioGroup>
            </div>
            <div className='col-12 px-0 input-padding-bottom'>
                <p className={"ibl-font-w-700 font-color-general-950 fs-14px"}>{t("payment_calculation_type")}</p>
            </div>
            <div className='col-12 col-md-6 px-1'>
                <CustomSelect
                    id='slt_rf_calculation_type'
                    name={'calculationType'}
                    value={rule?.calculationType}
                    keyName='id'
                    onChange={(e) => updateRuleField(e.target.name, e.target.value)}
                    list={CALCULATION_TYPE_MODEL()}
                    trans={'calculation_type'}
                    label={'calculationType'}
                    emptyFields={emptyFields}
                    required={true}
                    showNoSelectionOption={false}
                    disabled={disabled}
                />
            </div>

            <div className='col-12 col-md-6 px-1'>
                <CustomTextField
                    id='txt_rf_calculation_value'
                    name='calculationValue'
                    value={rule?.calculationValue}
                    trans='calculation_value'
                    type='text'
                    required
                    emptyFields={rule?.calculationType ? emptyFields : false}
                    onChange={(e) => updateRuleField(e.target.name, e.target.value)}
                    disabled={disabled ? disabled : !rule?.calculationType}
                    suffixText={<p className={"ibl-font-w-600 text-uppercase"}>{getCalculationTypeById(rule?.calculationType)?.prefixText}</p>}
                    isValid={rule?.calculationType ? isValidCalculationValue : true}
                    isValidText={isValidCalculationValueText}
                    decimals={2}
                    length={10}
                />
            </div>

            { ScopeComponent &&
                <>
                    <div className='col-12 px-0 input-padding-bottom'>
                        <p className={"ibl-font-w-700 font-color-general-950 fs-14px"}>{t("scope")}</p>
                    </div>
                    <ScopeComponent
                        t={t}
                        rule={rule}
                        updateRule={updateRuleField}
                        emptyFields={emptyFields}
                        isValid={isValid}
                        disabled={disabled}
                    />
                </>
            }
        </div>
    );
};

export default RuleForm;
